import { render, staticRenderFns } from "./cc.vue?vue&type=template&id=01f4ad2e&scoped=true"
import script from "./cc.vue?vue&type=script&lang=js"
export * from "./cc.vue?vue&type=script&lang=js"
import style0 from "./cc.vue?vue&type=style&index=0&id=01f4ad2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4ad2e",
  null
  
)

export default component.exports